import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useConsent } from "@/lib/consent";

/**
 * Floating button shown after the user has made a consent decision.
 * Required by ANPD: revocation must be as easy as giving consent.
 */
export function PrivacyTrigger() {
  const { t } = useTranslation();
  const { state, openManager, needsDecision } = useConsent();

  // Don't show while the banner is up — would be redundant.
  if (needsDecision || !state) return null;

  return (
    <Button
      onClick={openManager}
      variant="outline"
      size="sm"
      aria-label={t("consent.trigger.aria", "Gerenciar preferências de cookies")}
      className="fixed bottom-2 left-2 z-40 rounded-full glass-surface-strong glass-border shadow-sm hover:shadow-md transition-all gap-1.5 h-8 w-8 sm:h-auto sm:w-auto p-0 sm:pl-2 sm:pr-3 opacity-60 hover:opacity-100 pb-safe-min"
    >
      <ShieldCheck className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
      <span className="text-xs font-medium hidden sm:inline">
        {t("consent.trigger.label", "Cookies")}
      </span>
    </Button>
  );
}
